import ProductMdl from '@/models/Warehouse/WhProduct'

const includes = ['wh_item_pos', 'wh_tags', 'wh_subfamily_pos']

const appends = ['sale_price']

const fetchProduct = async function(productId) {
    try {
        let product = await ProductMdl.include(...includes)
            .append(...appends)
            .find(productId)
        return product
    } catch (error) {
        return error.response.data
    }
}

const getLike = async function(strSearch) {
    let mdl = new ProductMdl()
    let response = await mdl
        .include(...includes)
        .append(...appends)
        .where('search', strSearch)
        .limit(-1)
        .get()
    return response.data
}

export default {
    fetchProduct,
    getLike,
}
